
namespace appn.views.dataSources.settings {

    class InitArgs {
        googleAccessTokenUrl: string = emptyString;
        initPicker: boolean = false;
    }
    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;
        addEvents();
        appn.folderFilter.initLinkedFolders();

        if (_initArgs.initPicker) {
            setTimeout(() => {
                gapi.client.load('drive', 'v2');
                gapi.load('picker', () => { });
            }, 1000);
        }

        showHideFormData($('#RESTConnector_FormatType').val() as string);
        showHideFormDataPreStep($('#RESTConnector_PreStep_Format').val() as string);

        addTrashMessage();
        initInlineSelects();

        const connectionsSelect = $('select[id$="_ConnectionId"]');
        if (utils.hasValue(connectionsSelect))
            showHideSiteNameOrCamlFilterOnSelect(connectionsSelect);

        showHideSiteNameOrCamlFilter();

        const xeroConnector = $('.box-connector-Xero')
        if (utils.hasValue(xeroConnector))
            xeroUpdateEndpointSelect(xeroConnector);
    }

    function initInlineSelects() {
        select.init({ selector: '.box-connector-Rest #RESTConnector_HttpAction,.box-connector-Rest #RESTConnector_FormatType,.box-connector-Rest #RESTConnector_PreStep_Verb,.box-connector-Rest #RESTConnector_PreStep_Format', omitWidth: true });
    }

    function addEvents() {
        $('.connectorOption:not(.connection-required)').on('click', function() {
            if ($(this).data('upgrade-required')) {
                $('#upgradeReqd').modal('show');
                return;
            }

            const form = $('form#appnForm');
            form.append('<input type="hidden" name="submitType" value="' + $(this).attr('id') + '" />');
            form.submit();
        });

        $('#addConnector').click(function() {
            $('#connectorsDialog').modal('show');
        });

        $('.btnTryAddConnector').off().on('click', function(event) {
            event.preventDefault();
            $('#addConnector').click();
        });

        $('.btn-connector-run-now').off().on('click', function(event) {
            event.preventDefault();
            const link = $(this).attr('href') as string;
            appn.location.navTo(link);
        });

        $(document).on('click', '.addRestResponseMappingItem', function(event) {
            event.preventDefault();
            addRestResponseMappingItem();
        });

        $(document).on('click', '.deleteRestResponseMappingItem', function(event) {
            event.preventDefault();
            deleteRestResponseMapping($(this));
        });

        $(document).on('click', '.addRestHeaderItem', function(event) {
            event.preventDefault();
            addRestHeaderItem(emptyString);
        });

        $(document).on('click', '.deleteRestHeaderItem', function(event) {
            event.preventDefault();
            deleteRestHeaderItem($(this), emptyString);
        });

        $(document).on('click', '.addRestFormDataItem', function(event) {
            event.preventDefault();
            addRestFormDataItem(emptyString);
        });

        $(document).on('click', '.deleteRestFormDataItem', function(event) {
            event.preventDefault();
            deleteRestFormDataItem($(this), emptyString);
        });

        $(document).on('click', '.addRestHeaderItemPreStep', function(event) {
            event.preventDefault();
            addRestHeaderItem('PreStep');
        });

        $(document).on('click', '.deleteRestHeaderItemPreStep', function(event) {
            event.preventDefault();
            deleteRestHeaderItem($(this), 'PreStep');
        });

        $(document).on('click', '.addRestFormDataItemPreStep', function(event) {
            event.preventDefault();
            addRestFormDataItem('PreStep');
        });

        $(document).on('click', '.deleteRestFormDataItemPreStep', function(event) {
            event.preventDefault();
            deleteRestFormDataItem($(this), 'PreStep');
        });

        $(document).on('click', '.btnRestModifyHeaders', function(event) {
            event.preventDefault();
            $('.form-control-dsrest-headers').showElement();
            $('.btnRestModifyHeaders').hideElement();
        });

        $(document).on('click', '.btnRestModifyBody', function(event) {
            event.preventDefault();
            showHideBody($('#RESTConnector_FormatType').val() as string, true);
        });

        $(document).on('click', '.btnRestModifyHeadersPreStep', function(event) {
            event.preventDefault();
            $('.form-control-dsrest-headers-prestep').showElement();
            $('.btnRestModifyHeadersPreStep').hideElement();
        });

        $(document).on('click', '.btnRestModifyBodyPreStep', function(event) {
            event.preventDefault();
            showHideBodyPreStep($('#RESTConnector_PreStep_Format').val() as string, true);
        });

        $('#RESTConnector_FormatType').on('change', function() {
            showHideBody($(this).val() as string);
            showHideFormData($(this).val() as string);
        });

        $('#RESTConnector_PreStep_Format').on('change', function() {
            showHideBodyPreStep($(this).val() as string);
            showHideFormDataPreStep($(this).val() as string);
        }); 

        $(document).on('click', '.buildIcon', function() {
            const icon = $(this);

            let formulaInput = icon.closest('.input-group').find('textarea');
            const formulaInputValue = formulaInput.val() ? formulaInput.val() as string : formulaInput.text();

            appn.ui.formulabuilder.currentFormula = formulaInputValue;
            appn.ui.formulabuilder.currentMode = icon.data('type');
            appn.ui.formulabuilder.formulaUpdated = function(formula: string) {
                formulaInput.val(formula);
            };
            
            appn.ui.formulabuilder.showDialog();
        });

        $(document).on('input', '.responseMappingVal', function() {
            const currentVal = $(this).val() as string;
            if (!currentVal)
                return; // No current value

            const keyField = $(this).closest('tr').find('.responseMappingKey');
            const currentValLessLast = currentVal.substring(0, currentVal.length - 1);
            if (keyField.val() && currentValLessLast !== keyField.val())
                return; // If the key is already populated then bail so we don't overwrite

            if (!(currentVal as string).containsIgnoreCase('.')) {
                keyField.val(currentVal);
                return; // Nothing to replace
            }

            keyField.val((currentVal as string).replace(/\./g, '_'));
        });

        $(document).on('click', '.btnRestAddStep', function(event) {
            event.preventDefault();
            $('.restPreStepContainer,.btnRestRemoveStep,.appn-dropdown-group,.btnRestModifyHeadersPreStep').showElement();
            $('.btnRestAddStep').hideElement();
            showHideBodyPreStep($('#RESTConnector_PreStep_Format').val() as string);
            showHideFormDataPreStep($('#RESTConnector_PreStep_Format').val() as string);
        });

        $(document).on('click', '.btnRestRemoveStep', function(event) {
            event.preventDefault();
            $('.btnRestAddStep').showElement();
            $('.restPreStepContainer,.btnRestRemoveStep,.appn-dropdown-group,.btnRestModifyHeadersPreStep,.btnRestModifyBodyPreStep').hideElement();
            $('#RESTConnector_PreStep_Url').val(emptyString);
            $('#RESTConnector_PreStep_Format').val('Json');
            $('#RESTConnector_PreStep_Body').val(emptyString);
            clearRestFormDataItems('PreStep');
            clearRestHeaderItems('PreStep');
        });

        $(document).on('change', '#RESTConnector_HttpAction', function(event) {
            showHideBody($('#RESTConnector_FormatType').val() as string);
            showHideFormData($('#RESTConnector_FormatType').val() as string);
        });

        $(document).on('change', '#RESTConnector_PreStep_Verb', function(event) {
            showHideBodyPreStep($('#RESTConnector_PreStep_Format').val() as string);
            showHideFormDataPreStep($('#RESTConnector_PreStep_Format').val() as string);
        });

        $('select[id$="_ConnectionId"]').on('change', function () {
            showHideSiteNameOrCamlFilterOnSelect($(this));
        });

        // OneDriveBusiness
        $('input.graph-sitename-input').on('change', function () {
            const siteName = $(this);
            const connector = siteName.closest('.connector');
            const inputDriveName = connector.find('div.input-drive-name');

            // If there is a siteNameElement, we know that the connection is Graph
            inputDriveName.toggleClass('d-none', !siteName || !siteName.val());
        });

        // OneDriveBusiness & Google
        $('select[id$="ConnectionId"]').on('change', function () {
            const connector = $(this).closest('.connector');
            const connectionType = $(this).find(':selected').data('appnConnectionType') as string;

            if (connectionType.toLowerCase() === 'google') {
                const useRestricted = $(this).find(':selected').data('googleUseRestricted') as string;
                if (useRestricted.toLowerCase() === 'true') {
                    connector.find('.restricted-scopes').removeClass('d-none');
                    connector.find('.unrestricted-scopes').addClass('d-none');
                }
                else {
                    connector.find('.restricted-scopes').addClass('d-none');
                    connector.find('.unrestricted-scopes').removeClass('d-none');
                }
            }
            else {
                const siteName = connector.find('input.graph-sitename-input');
                const inputDriveName = connector.find('div.input-drive-name');

                // If there is a siteNameElement, we know that the connection is Graph
                inputDriveName.toggleClass('d-none', !siteName || !siteName.val());
            }
        });

        // Xero Connector
        $(document).on('change', '#XeroConnector_Api', function() {
            const connector = $('div[class*="box-connector-Xero"]');
            xeroUpdateEndpointSelect(connector);

            const apiValue = $(this).val() as string;
            const endpoint = connector.find('select[id$="_Endpoint"]');
            const endpointValue = endpoint.val() as string;

            xeroTogglePropertiesOnApiEndpointSelect(connector, apiValue, endpointValue);
        });

        $(document).on('change', '#XeroConnector_Endpoint', function() {
            const connector = $(this).closest('.connector');
            const apiValue = connector.find('select[id$="_Api"]').val() as string;
            const endpointValue = $(this).val() as string;

            xeroTogglePropertiesOnApiEndpointSelect(connector, apiValue, endpointValue);
        });

        // Google Sheet Picker
        $('.btn-google-picker').on('click', function (e) {
            e.preventDefault();
            const connector = $(this).closest('.connector');
            const connectionId = connector.find('[id$="ConnectionId"]').val();
            const pickerId = connector.find('.google-picker-id');
            const pickerName = connector.find('.google-picker-name');
            const spreadsheet = connector.find('.google-spreadsheet');

            $.ajax({
                headers: appn.verifyHeader,
                url: _initArgs.googleAccessTokenUrl,
                type: 'POST',
                data: { connId: connectionId },
                success: function (data, status, xhttp) {
                    const response = JSON.parse(data);
                    var view = new google.picker.DocsView()
                        .setIncludeFolders(true);

                    if (spreadsheet.length === 0)
                        view.setMimeTypes('text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    else
                        view.setMimeTypes('application/vnd.google-apps.spreadsheet');

                    this.picker = new google.picker.PickerBuilder()
                        .setAppId(response.ClientId)
                        .setOAuthToken(response.accessToken)
                        .addView(view)
                        .setCallback(function (data) {
                            if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
                                var file = data[google.picker.Response.DOCUMENTS][0];
                                var id = file[google.picker.Document.ID];
                                pickerId.val(id);
                                pickerName.val(file.name);
                            }
                        })
                        .build()
                        .setVisible(true);
                },
                error: function (data, message, message2) {
                    appn.toast.notify(toast.Type.error, T('Could not fetch access token.'));
                }
            });
        });
            
        $('#featurelayerheadings').on('change', function (this: HTMLElement, event: any) {
            event.preventDefault();
            if ($(this).val() === '0')
                return;

            const columnName = $(this).val() as string;
            const type: elementBuilder.RowType = elementBuilder.RowType[$(this).find('option:checked').attr('row-type') as keyof typeof elementBuilder.RowType];

            const idx = $('#FeatureLayerMapping tbody').children().length;

            if (idx == 0)
                $('#FeatureLayerMapping').removeClass("d-none");

            const newRow = `<tr>` +
                `<td class="dataCol name"> <input class="mappingKey" type="hidden" name="ArcGisConnector.FeatureLayerMappings[${idx}].DisplayName" value="${$(this).val()}"/><label class="col-form-label col-form-label-sm mappingKey" name="ArcGisConnector.FeatureLayerMappings[${idx}].DisplayName">${$(this).val()}</label></td>` +
                `<td class="dataCol value"><input class="form-control form-control-sm mappingVal" type="text" name="ArcGisConnector.FeatureLayerMappings[${idx}].ColumnName" value="${$(this).val()}"></td>` +
                `<td class="text-right activity-row-options">` +
                    `<div class="btn-group" role="group">` +
                        `${elementBuilder.buildBtnMoveRow(true)}` +
                        `${elementBuilder.buildBtnMoveRow(false)}` +
                        `${elementBuilder.buildBtnRemoveRow('delete_button')}` +
                    `</div>` +
                `</td>`;

            $(`#FeatureLayerMapping tbody`).append(newRow);

            // Disable the selected element
            $(`#featurelayerheadings option[value="${$(this).val()}"]`).prop('disabled', true);

            // Reset the selected index of the select list to the first index
            $(`#featurelayerheadings`).val('0');

            select.init();
        });

        $(document).on('click', '.delete_button', function (e) {
            e.preventDefault();
            const tableId = $(this).closest('table').attr('id');
            if (tableId === 'FeatureLayerMapping') {
                const row = $(this).parents('tr');
                $(`#featurelayerheadings option[value="${row.find('.mappingKey').text()}"]`).prop('disabled', false);
                row.remove();

                renameFeatureLayerMapping();
            }
        });

        $(document).on('click', '.down_button', function () {
            const tableId = $(this).closest('table').attr('id');
            if (tableId === 'FeatureLayerMapping') {
                const rowToMove = $(this).parents('#FeatureLayerMapping tbody tr:first');
                const next = rowToMove.next('#FeatureLayerMapping tbody tr');
                if (next.length === 1) {
                    next.after(rowToMove);
                    renameFeatureLayerMapping();
                }
            }
        });

        $(document).on('click', '.up_button', function () {
            const tableId = $(this).closest('table').attr('id');
            if (tableId === 'FeatureLayerMapping') {
                const rowToMove = $(this).parents('#FeatureLayerMapping tbody tr:first');
                const prev = rowToMove.prev('#FeatureLayerMapping tbody tr');
                if (prev.length === 1) {
                    prev.before(rowToMove);
                    renameFeatureLayerMapping();
                }
            }
        });
    }

    function renameFeatureLayerMapping() {
        // rename all remaining rows to keep continuous index
        let idx = 0;
        $('#FeatureLayerMapping tbody tr').each(function (index: number, row: HTMLElement): any {
            $(this).find('.mappingKey').attr('name', `ArcGisConnector.FeatureLayerMappings[${idx}].DisplayName`);
            $(this).find('.mappingVal').attr('name', `ArcGisConnector.FeatureLayerMappings[${idx}].ColumnName`);
            idx++;
        });
    }

    function addTrashMessage() {
        const submitButton = $('nav .navbar-nav-right button[value="Trash"].btn-danger');
        submitButton.attr('data-trashdetail', emptyString);
        const p = elementBuilder.createElement('p', undefined, undefined, undefined, `<b>${$('#DataSource_Name').val()}</b> will be moved to Trash and will no longer be available for use.`);
        submitButton.attr('data-trashdetail', JSON.stringify(p.outerHTML));
    }

    function showHideBody(dataType: string, isBtnClick?: boolean) {
        const httpVerb = $('#RESTConnector_HttpAction').val();
        if (httpVerb === 'Get') {
            // Get never has a body, remove both the textbox and btns
            $('.btnRestModifyBody').hideElement();
            $('.form-control-dsrest-body').hideElement();
            return;
        }

        if (dataType === 'Xml' || dataType === 'Json') {
            if ($('#RESTConnector_Body').val() as string || isBtnClick) {
                $('.form-control-dsrest-body').showElement();
                $('.btnRestModifyBody').hideElement();
                return;
            }

            $('.form-control-dsrest-body').hideElement();
            $('.btnRestModifyBody').showElement();
            return;
        }

        // Url encoded
        $('.form-control-dsrest-body').hideElement();
        $('.btnRestModifyBody').hideElement();
    }

    function showHideFormData(dataType: string) {
        const httpVerb = $('#RESTConnector_HttpAction').val() as string;
        if (httpVerb === 'Get') {
            $('#RESTConnector_FormatType option[value="UrlEncoded"]').attr('disabled', 'disabled');
            $('.form-control-dsrest-formData').hideElement();

            if ($('#RESTConnector_FormatType').val() === 'UrlEncoded')
                $('#RESTConnector_FormatType').val('Json');

            return;
        }

        $('#RESTConnector_FormatType option[value="UrlEncoded"]').removeAttr('disabled');
        initInlineSelects();

        if (dataType === 'UrlEncoded') {
            $('.form-control-dsrest-formData').showElement();
            return;
        }

        $('.form-control-dsrest-formData').hideElement();
    }

    function showHideBodyPreStep(dataType: string, isBtnClick?: boolean) {
        const httpVerb = $('#RESTConnector_PreStep_Verb').val();
        if (httpVerb === 'Get') {
            // Get never has a body, remove both the textbox and btns
            $('.btnRestModifyBodyPreStep').hideElement();
            $('.form-control-dsrest-body-prestep').hideElement();
            return;
        }

        if (dataType === 'Xml' || dataType === 'Json') {
            if ($('#RESTConnector_PreStep_Body').val() as string || isBtnClick) {
                $('.form-control-dsrest-body-prestep').showElement();
                $('.btnRestModifyBodyPreStep').hideElement();
                return;
            }

            $('.form-control-dsrest-body-prestep').hideElement();
            $('.btnRestModifyBodyPreStep').showElement();
            return;
        }

        // URL encoded
        $('.form-control-dsrest-body-prestep').hideElement();
        $('.btnRestModifyBodyPreStep').hideElement();
    }

    function showHideFormDataPreStep(dataType: string) {
        const httpVerb = $('#RESTConnector_PreStep_Verb').val() as string;
        if (httpVerb === 'Get') {
            $('#RESTConnector_PreStep_Format option[value="UrlEncoded"]').attr('disabled', 'disabled');
            $('.form-control-dsrest-formData-prestep').hideElement();

            if ($('#RESTConnector_PreStep_Format').val() === 'UrlEncoded')
                $('#RESTConnector_PreStep_Format').val('Json');

            return;
        }

        $('#RESTConnector_PreStep_Format option[value="UrlEncoded"]').removeAttr('disabled');
        initInlineSelects();

        if (dataType === 'UrlEncoded') {
            $('.form-control-dsrest-formData-prestep').showElement();
            return;
        }

        $('.form-control-dsrest-formData-prestep').hideElement();
    }

    function deleteRestResponseMapping(_this: JQuery<HTMLElement>) {
        _this.parents('tr').remove();

        renameRestResponseMappingRows();

        if ($('#restResponseMapping tbody').children().length === 0) {
            $('#restResponseMapping').hideElement();
            $('.addRestResponseMappingItem').css('top', '-20px');
        }
    }

    function addRestResponseMappingItem() {
        if ($('#restResponseMapping tbody').children().length === 0) {
            $('#restResponseMapping').showElement();
            $('.addRestResponseMappingItem').css('top', '0px');
        }

        const idx = $('#restResponseMapping tbody').children().length;

        const newRow = `<tr>` +
            `<td class="dataCol"><input class="form-control form-control-sm responseMappingVal" type="text" name="RESTConnector.ResponseMapping[${idx}].Val" id="RESTConnector_ResponseMapping_${idx}__Val"></td>` +
            `<td class="dataCol"><input class="form-control form-control-sm responseMappingKey" type="text" name="RESTConnector.ResponseMapping[${idx}].Key" id="RESTConnector_ResponseMapping_${idx}__Key"></td>` +
            `<td class="closeCell">${elementBuilder.buildBtnRemoveRow('deleteRestResponseMappingItem', 'data-tablename="responseMapping"')}</td>` +
            `</tr>`;

        $('#restResponseMapping tbody').append(newRow);
    }

    function renameRestResponseMappingRows() {
        // Rename all remaining rows to keep continuous index
        $('#restResponseMapping tbody tr').each(function(index, row) {
            $(this).find('.responseMappingKey')
                .attr('name', `RESTConnector.ResponseMapping[${index}].Key`)
                .attr('id', `RESTConnector_ResponseMapping_${index}__Key`);

            $(this).find('.responseMappingVal')
                .attr('name', `RESTConnector.ResponseMapping[${index}].Val`)
                .attr('id', `RESTConnector_ResponseMapping_${index}__Val`);
        });
    }

    function deleteRestHeaderItem(_this: JQuery<HTMLElement>, suffix: string) {
        _this.closest('tr').remove();

        renameRestHeaderRows(suffix);

        if ($(`#restHeaders${suffix} tbody`).children().length === 0) {
            $(`#restHeaders${suffix}`).hideElement();
            $(`.addRestHeaderItem${suffix}`).css('top', '-20px');
        }
    }

    function clearRestHeaderItems(suffix: string) {
        $(`#restHeaders${suffix} tbody tr`).each(function(index, item) {
            deleteRestHeaderItem($(item), suffix);
        });

        $('.form-control-dsrest-headers-prestep').hideElement();
    }

    function addRestHeaderItem(suffix: string) {
        if ($(`#restHeaders${suffix} tbody`).children().length === 0) {
            $(`#restHeaders${suffix}`).showElement();
            $(`.addRestHeaderItem${suffix}`).css('top', '0px');
        }

        const idx = $(`#restHeaders${suffix} tbody`).children().length;

        const newRow = `<tr>` +
            `<td class="dataCol"><input class="form-control form-control-sm headerKey${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : emptyString)}.Headers[${idx}].Key" id="RESTConnector${(suffix ? '_PreStep' : emptyString)}_Headers_${idx}__Key"></td>` +
            `<td class="dataCol"><div class="input-group input-group-sm"><textarea class="form-control form-control-sm headerVal${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : emptyString)}.Headers[${idx}].Val" id="RESTConnector${(suffix ? '_PreStep' : emptyString)}_Headers_${idx}__Val"></textarea><span class="input-group-append">${appn.elementBuilder.buildIconButton('template')}</span></div></td>` +
            `<td class="closeCell">${elementBuilder.buildBtnRemoveRow(`deleteRestHeaderItem${suffix}`, `data-tablename="restHeaders${suffix}"`)}</td>` +
            `</tr>`;

        $(`#restHeaders${suffix} tbody`).append(newRow);
    }

    function renameRestHeaderRows(suffix: string) {
        // rename all remaining rows to keep continuous index
        $(`#restHeaders${suffix} tbody tr`).each(function(index, row) {
            $(this).find(`.headerKey${suffix}`)
                .attr('name', `RESTConnector${(suffix ? '.PreStep' : emptyString)}.Headers[${index}].Key`)
                .attr('id', `RESTConnector${(suffix ? '_PreStep' : emptyString)}_Headers_${index}__Key`);

            $(this).find(`.headerVal${suffix}`)
                .attr('name', `RESTConnector${(suffix ? '.PreStep' : emptyString)}.Headers[${index}].Val`)
                .attr('id', `RESTConnector${(suffix ? '_PreStep' : emptyString)}_Headers_${index}__Val`);
        });
    }

    function deleteRestFormDataItem(_this: JQuery<HTMLElement>, suffix: string) {
        _this.closest('tr').remove();

        renameRestFormDataRows(suffix);

        if ($(`#restFormData${suffix} tbody`).children().length === 0) {
            $(`#restFormData${suffix}`).hideElement();
            $(`.addRestFormDataItem${suffix}`).css('top', '-20px');
        }
    }

    function clearRestFormDataItems(suffix: string) {
        $(`#restFormData${suffix} tbody tr`).each(function(index, item) {
            deleteRestFormDataItem($(item), suffix);
        });

        $('.form-control-dsrest-formData-prestep').hideElement();
    }

    function addRestFormDataItem(suffix: string) {
        if ($(`#restFormData${suffix} tbody`).children().length === 0) {
            $(`#restFormData${suffix}`).showElement();
            $(`.addRestFormDataItem${suffix}`).css('top', '0px');
        }

        const idx = $(`#restFormData${suffix} tbody`).children().length;

        const newRow = `<tr>` +
            `<td class="dataCol"><input class="form-control form-control-sm formDataKey${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : emptyString)}.FormData[${idx}].Key" id="RESTConnector${(suffix ? '_PreStep' : emptyString)}_FormData_${idx}__Key"></td>` +
            `<td class="dataCol"><div class="input-group input-group-sm"><textarea class="form-control form-control-sm formDataVal${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : emptyString)}.FormData[${idx}].Val" id="RESTConnector${(suffix ? '_PreStep' : emptyString)}_FormData_${idx}__Val"></textarea><span class="input-group-append">${appn.elementBuilder.buildIconButton('template')}</span></div></td>` +
            `<td class="closeCell">${elementBuilder.buildBtnRemoveRow(`deleteRestFormDataItem${suffix}`, `data-tablename="restFormData${suffix}"`)}</td>` +
            `</tr>`;

        $(`#restFormData${suffix} tbody`).append(newRow);
    }

    function renameRestFormDataRows(suffix: string) {
        // rename all remaining rows to keep continuous index
        $(`#restFormData${suffix} tbody tr`).each(function(index, row) {
            $(this).find(`.formDataKey${suffix}`)
                .attr('name', `RESTConnector${(suffix ? '.PreStep' : emptyString)}.FormData[${index}].Key`)
                .attr('id', `RESTConnector${(suffix ? '_PreStep' : emptyString)}_FormData_${index}__Key`);

            $(this).find(`.formDataVal${suffix}`)
                .attr('name', `RESTConnector${(suffix ? '.PreStep' : emptyString)}.FormData[${index}].Val`)
                .attr('id', `RESTConnector${(suffix ? '_PreStep' : emptyString)}_FormData_${index}__Val`);
        });
    }

    function toggleInputHideOrShowForGroup(connector: JQuery<HTMLElement>, groupName: string): void {
        const siteName = connector.find('#OneDriveBusinessConnector_SiteName').closest('div.row');
        const camlFilterQuery = $('.caml-filter-query');
        const graphFilter = $('.graph-filter');

        // OneDriveBusiness
        if (groupName !== 'MicrosoftGraph' && utils.hasValue(siteName)) {
            siteName.find('input').val(emptyString);
            siteName.hideElement();
        } else if (groupName === 'MicrosoftGraph' && utils.hasValue(siteName))
            siteName.showElement();

        // SharePoint
        if (groupName !== 'MicrosoftGraph' && utils.hasValue(camlFilterQuery) && utils.hasValue(graphFilter)) {
            camlFilterQuery.showElement();
            graphFilter.hideElement();
        } else if (groupName === 'MicrosoftGraph' && utils.hasValue(camlFilterQuery) && utils.hasValue(graphFilter)) {
            graphFilter.showElement();
            camlFilterQuery.hideElement();
        }
    }

    function showHideSiteNameOrCamlFilter(connector?: JQuery<HTMLElement>) {
        if (!utils.hasValue(connector) || connector === undefined)
            connector = $('div[class*="box-connector-"]');

        if (!utils.hasValue(connector))
            return;

        const classes = connector.attr('class')!.split(' ');
        const groupName = classes.filter((o) => o.contains('group-'))[0]?.replace('group-', emptyString);

        if (!utils.hasValue(groupName) || groupName === 'None')
            return;

        if (groupName !== 'OneDriveBusiness' && groupName !== 'SharePoint' && groupName !== 'MicrosoftGraph')
            return;

        toggleInputHideOrShowForGroup(connector, groupName);
    }

    function showHideSiteNameOrCamlFilterOnSelect(select: JQuery<HTMLElement>) {
        const connector = $(select).closest('.connector');
        const classes = connector.attr('class')!.split(' ').filter((o) => {
            return o.indexOf('box-connector-') > -1;
        });

        if (classes.length < 1)
            return;

        const connectorName = classes[0].replace('box-connector-', emptyString);
        if (connectorName !== 'OneDriveBusiness' && connectorName !== 'SharePoint')
            return;

        const selected = $(select).val();
        const groupName = $(select).find(`option[value="${selected}"]`).closest('optgroup').attr('label') as string;
        toggleInputHideOrShowForGroup(connector, groupName.replace(' ', ''));
    }

    const xeroEndpointOptionDisplay: Record<string, string> = {};
    function xeroUpdateEndpointSelect(connector: JQuery<HTMLElement>) {
        const endpoint = connector.find('select[id$="XeroConnector_Endpoint"]');
        const apiSelect = connector.find('select[id$="XeroConnector_Api"]');

        // cache display values the first time we replace this select
        if (!xeroEndpointOptionDisplay[XeroEndpoint.Accounts]) {
            endpoint.find('option').each((_, o) => {
                const option = $(o);
                xeroEndpointOptionDisplay[option.val() as string] = option.text();
            });
        }

        // create a template select dropdown that we can mutate -> add -> and then initialize dynamically
        const group: SelectListGroup = {
            Disabled: false,
            Name: emptyString
        }
        const selectOptionTemplate: Array<SelectListItem> = [];
        for (const key in XeroEndpoint) {
            if (Object.prototype.hasOwnProperty.call(XeroEndpoint, key)) {
                selectOptionTemplate.push({
                    disabled: false,
                    group: group,
                    selected: key === endpoint.val() as string,
                    text: xeroEndpointOptionDisplay[key] ?? key,
                    value: key
                });
            }
        }

        const newSelect = $(appn.elementBuilder.buildSelectGeneric(selectOptionTemplate,
            endpoint.attr('id') as string,
            endpoint.attr('class') as string,
            T('Select Endpoint'),
            endpoint.attr('name') as string));
        const options = newSelect.find('option');

        const accountingOptions = ['Accounts', 'Contacts', 'Invoices', 'Items', 'TrackingCategories'];
        const payrollOptions = ['Timesheet', 'Employees']
        switch (apiSelect.val() as string) {
            case XeroApi.None: {
                newSelect.attr('disabled', 'disabled');
                options.each((_, o) => {
                    const option = $(o);
                    option.removeAttr('selected');
                    if ((option.val() as string) === '')
                        option.attr('selected', 'selected');
                });
                break;
            }
            case XeroApi.Accounting: {
                options.each((_, o) => {
                    const option = $(o);
                    if (!accountingOptions.includes(option.val() as string))
                        option.remove();
                });
                break;
            }
            case XeroApi.PayrollAU:
            case XeroApi.PayrollUK:
            case XeroApi.PayrollNZ: {
                options.each((i, o) => {
                    const option = $(o);
                    if (!payrollOptions.includes(option.val() as string))
                        option.remove();
                });
                break;
            }
        }

        endpoint.replaceWith(newSelect);
        // re-initialize the select2 list once done
        select.init({ selector: `.box-connector-Xero #${newSelect.attr('id') as string}` });
    }
    
    function xeroTogglePropertiesOnApiEndpointSelect(connector: JQuery<any>, api: string, endpoint: string){
        connector.find('.accounts').hideElement();
        connector.find('.contacts').hideElement();
        connector.find('.auEmployees').hideElement();
        connector.find('.ukNzEmployees').hideElement();
        connector.find('.invoices').hideElement();
        connector.find('.items').hideElement();
        connector.find('.trackingCats').hideElement();
        connector.find('.auTimesheets').hideElement();
        connector.find('.ukNzTimesheets').hideElement();

        switch (endpoint) {
            case XeroEndpoint.Accounts:
                connector.find('.accounts').showElement();
                break;
            case XeroEndpoint.Contacts:
                connector.find('.contacts').showElement();
                break;
            case XeroEndpoint.Employees:
                switch (api){
                    case XeroApi.PayrollAU:
                        connector.find('.auEmployees').showElement();
                        break;
                    case XeroApi.PayrollUK:
                    case XeroApi.PayrollNZ:
                        connector.find('.ukNzEmployees').showElement();
                        break;
                }
                break;
            case XeroEndpoint.Invoices:
                connector.find('.invoices').showElement();
                break;
            case XeroEndpoint.Items:
                connector.find('.items').showElement();
                break;
            case XeroEndpoint.TrackingCategories:
                connector.find('.trackingCats').showElement();
                break;
            case XeroEndpoint.Timesheet:
                switch (api){
                    case XeroApi.PayrollAU:
                        connector.find('.auTimesheets').showElement();
                        break;
                    case XeroApi.PayrollUK:
                    case XeroApi.PayrollNZ:
                        connector.find('.ukNzTimesheets').showElement();
                        break;
                }
                break;
        }
    }
}
